import { Stack, Text } from '@chakra-ui/react'
import { useTranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'
import React from 'react'
import { CustomConfirmDialog } from './CustomConfirmDialog'

interface BmwPriceChangedDialogProps {
  isOpen: boolean
  priceError: string | null
  onClose: () => void
  onConfirm: () => void
}

export const BmwPriceChangedDialog: React.FC<BmwPriceChangedDialogProps> = ({
  isOpen,
  priceError,
  onClose,
  onConfirm,
}) => {
  const { translate } = useTranslationsContext()

  return (
    <CustomConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      title={translate('changeCalculation', 'Změna kalkulace')}
      yesButton={{
        text: translate('continue', 'Pokračovat'),
        onClick: onConfirm,
      }}
      noButton={{
        text: translate('cancel', 'Zrušit'),
        onClick: onClose,
      }}
    >
      <Stack>
        <Text>{priceError}</Text>
        <Text>
          {translate(
            'doYouWantToContinueWithTheChange',
            'Chcete pokračovat se změnou?',
          )}
        </Text>
      </Stack>
    </CustomConfirmDialog>
  )
}
